module.exports = __webpack_public_path__ + "img/s6.e72517cf.jpg";